const carrierSelectionOptions = [
    {
        "carrierCode": "Allied_Express",
        "carrierName": "Allied Express",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Allied_Express_Road_Express",
                "serviceName": "Allied Express - Road Express",
                "countries": [
                    "AU"
                ]
            }
        ]
    },
    {
        "carrierCode": "Aramex",
        "carrierName": "Aramex",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Aramex_Domestic_Pick_up_to_delivery",
                "serviceName": "Aramex - Domestic (Pick up to delivery)",
                "countries": [
                    "SG"
                ]
            },
            {
                "serviceCode": "Aramex_Parcel",
                "serviceName": "Aramex - Parcel",
                "countries": [
                    "SG",
                    "HK",
                    "NZ"
                ]
            },
            {
                "serviceCode": "Aramex_Parcel_Domestic",
                "serviceName": "Aramex - Parcel (Domestic)",
                "countries": [
                    "NZ"
                ]
            },
            {
                "serviceCode": "Aramex_Parcel_EPX_hybrid_EU_and_US",
                "serviceName": "Aramex - Parcel EPX (hybrid EU and US)",
                "countries": [
                    "HK"
                ]
            },
            {
                "serviceCode": "Aramex_Parcel_to_SA_and_AE_DDP",
                "serviceName": "Aramex - Parcel to SA and AE (DDP)",
                "countries": [
                    "HK"
                ]
            }
        ]
    },
    {
        "carrierCode": "Asendia",
        "carrierName": "Asendia",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Asendia_ePAQ_Plus_DDUHVN",
                "serviceName": "Asendia - ePAQ Plus (DDUHVN)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Asendia_ePAQ_Plus_DDULAX",
                "serviceName": "Asendia - ePAQ Plus (DDULAX)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Asendia_ePAQ_Plus_DDUMIA",
                "serviceName": "Asendia - ePAQ Plus (DDUMIA)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Asendia_ePAQ_Plus_DDUORD",
                "serviceName": "Asendia - ePAQ Plus (DDUORD)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Asendia_ePAQ_Plus_DDUPHL",
                "serviceName": "Asendia - ePAQ Plus (DDUPHL)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Asendia_Epaq_Plus_Hermes",
                "serviceName": "Asendia - Epaq Plus (Hermes)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Asendia_ePAQ_Select_HVN",
                "serviceName": "Asendia - ePAQ Select (HVN)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Asendia_ePAQ_Select_LAX_Hermes",
                "serviceName": "Asendia - ePAQ Select LAX (Hermes)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Asendia_ePAQ_Select_MIA",
                "serviceName": "Asendia - ePAQ Select (MIA)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Asendia_ePAQ_Select_ORD",
                "serviceName": "Asendia - ePAQ Select (ORD)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Asendia_ePAQ_Select_PHL",
                "serviceName": "Asendia - ePAQ Select (PHL)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Asendia_ePAQ_Standard_HVN",
                "serviceName": "Asendia - ePAQ Standard (HVN)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Asendia_ePAQ_Standard_LAX",
                "serviceName": "Asendia - ePAQ Standard (LAX)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Asendia_ePAQ_Standard_MIA",
                "serviceName": "Asendia - ePAQ Standard (MIA)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Asendia_ePAQ_Standard_ORD",
                "serviceName": "Asendia - ePAQ Standard (ORD)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Asendia_ePAQ_Standard_PHL",
                "serviceName": "Asendia - ePAQ Standard (PHL)",
                "countries": [
                    "US"
                ]
            }
        ]
    },
    {
        "carrierCode": "BPOST",
        "carrierName": "BPOST",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Belgium_Post_Domestic",
                "serviceName": "Belgium Post - Domestic",
                "countries": [
                    "BE"
                ]
            },
            {
                "serviceCode": "Belgium_Post_international",
                "serviceName": "Belgium Post - international",
                "countries": [
                    "BE"
                ]
            }
        ]
    },
    {
        "carrierCode": "Bringer",
        "carrierName": "Bringer",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Bringer_Packet_Standard_MIA",
                "serviceName": "Bringer - Packet Standard (MIA)",
                "countries": [
                    "US"
                ]
            }
        ]
    },
    {
        "carrierCode": "BRT",
        "carrierName": "BRT",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "BRT_Return",
                "serviceName": "BRT - Return",
                "countries": [
                    "IT"
                ]
            }
        ]
    },
    {
        "carrierCode": "Canada_Post",
        "carrierName": "Canada Post",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Canada_Post_Expedited_Parcel",
                "serviceName": "Canada Post - Expedited Parcel",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canada_Post_Expedited_Parcel_USA",
                "serviceName": "Canada Post - Expedited Parcel - USA",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canada_Post_International_Parcel_Air",
                "serviceName": "Canada Post - International Parcel - Air",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canada_Post_International_Parcel_Surface",
                "serviceName": "Canada Post - International Parcel - Surface",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canada_Post_International_Small_Packet_Surface",
                "serviceName": "Canada Post - International Small Packet - Surface",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canada_Post_International_Tracked_Packet",
                "serviceName": "Canada Post - International Tracked Packet",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canada_Post_Priority",
                "serviceName": "Canada Post - Priority",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canada_Post_Regular_Parcel",
                "serviceName": "Canada Post - Regular Parcel",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canada_Post_Small_Packet_International_Air",
                "serviceName": "Canada Post - Small Packet International - Air",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canada_Post_Small_Packet_USA",
                "serviceName": "Canada Post - Small Packet - USA",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canada_Post_USA_Tracked_Parcel",
                "serviceName": "Canada Post - USA Tracked Parcel",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canada_Post_Xpresspost",
                "serviceName": "Canada Post - Xpresspost",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canada_Post_Xpresspost_International",
                "serviceName": "Canada Post - Xpresspost - International",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canada_Post_Xpresspost_USA",
                "serviceName": "Canada Post - Xpresspost - USA",
                "countries": [
                    "CA"
                ]
            }
        ]
    },
    {
        "carrierCode": "Canpar",
        "carrierName": "Canpar",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Canpar_Express",
                "serviceName": "Canpar - Express",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canpar_Express_Pak",
                "serviceName": "Canpar - Express Pak",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canpar_Ground",
                "serviceName": "Canpar - Ground",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canpar_International",
                "serviceName": "Canpar - International",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canpar_Select",
                "serviceName": "Canpar - Select",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canpar_Select_Pak",
                "serviceName": "Canpar - Select Pak",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canpar_Select_USA",
                "serviceName": "Canpar - Select USA",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canpar_USA",
                "serviceName": "Canpar - USA",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Canpar_USA_Pak",
                "serviceName": "Canpar - USA Pak",
                "countries": [
                    "CA"
                ]
            }
        ]
    },
    {
        "carrierCode": "Chronopost",
        "carrierName": "Chronopost",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Chronopost_Chrono_10",
                "serviceName": "Chronopost - Chrono 10",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Chronopost_Chrono_13",
                "serviceName": "Chronopost - Chrono 13",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Chronopost_Chrono_18",
                "serviceName": "Chronopost - Chrono 18",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Chronopost_Chrono_Classic",
                "serviceName": "Chronopost - Chrono Classic",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Chronopost_Chrono_Express",
                "serviceName": "Chronopost - Chrono Express",
                "countries": [
                    "FR"
                ]
            }
        ]
    },
    {
        "carrierCode": "Colis_Prive",
        "carrierName": "Colis Prive",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Colis_Prive_Home",
                "serviceName": "Colis Prive - Home",
                "countries": [
                    "FR"
                ]
            }
        ]
    },
    {
        "carrierCode": "Colissimo",
        "carrierName": "Colissimo",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Colissimo_Access",
                "serviceName": "Colissimo - Access",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Colissimo_Expert",
                "serviceName": "Colissimo - Expert",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Colissimo_Home_return",
                "serviceName": "Colissimo - Home return",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Colissimo_International",
                "serviceName": "Colissimo - International",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Colissimo_International_Return",
                "serviceName": "Colissimo - International Return",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Colissimo_International_Return_bulky",
                "serviceName": "Colissimo - International Return bulky",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Colissimo_International_Return_new",
                "serviceName": "Colissimo - International Return new",
                "countries": [
                    "FR"
                ]
            }
        ]
    },
    {
        "carrierCode": "Correos",
        "carrierName": "Correos",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Correos_Returns",
                "serviceName": "Correos - Returns",
                "countries": [
                    "ES"
                ]
            }
        ]
    },
    {
        "carrierCode": "CouriersPlease",
        "carrierName": "CouriersPlease",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "CouriersPlease_Authority_To_Leave_0_5kg_0_5kg",
                "serviceName": "CouriersPlease - Authority To Leave - 0.5kg (0.5kg)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "CouriersPlease_Authority_To_Leave_10kg_10kilo",
                "serviceName": "CouriersPlease - Authority To Leave - 10kg (10kilo)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "CouriersPlease_Authority_To_Leave_1kg_1kilo",
                "serviceName": "CouriersPlease - Authority To Leave - 1kg (1kilo)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "CouriersPlease_Authority_To_Leave_25kg_25kilo",
                "serviceName": "CouriersPlease - Authority To Leave - 25kg (25kilo)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "CouriersPlease_Authority_To_Leave_3kg_3kilo",
                "serviceName": "CouriersPlease - Authority To Leave - 3kg (3kilo)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "CouriersPlease_Authority_To_Leave_5kg_5kilo",
                "serviceName": "CouriersPlease - Authority To Leave - 5kg (5kilo)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "CouriersPlease_Multi_Box_Pronto",
                "serviceName": "CouriersPlease - Multi Box Pronto",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "CouriersPlease_Multi_Box_STD",
                "serviceName": "CouriersPlease - Multi Box STD",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "CouriersPlease_Signature_0_5kg_0_5kg",
                "serviceName": "CouriersPlease - Signature - 0.5kg (0.5kg)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "CouriersPlease_Signature_10kg_10kg",
                "serviceName": "CouriersPlease - Signature - 10kg (10kg)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "CouriersPlease_Signature_1kg_1kg",
                "serviceName": "CouriersPlease - Signature - 1kg (1kg)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "CouriersPlease_Signature_3kg_3kg",
                "serviceName": "CouriersPlease - Signature - 3kg (3kg)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "CouriersPlease_Signature_5kg_5kg",
                "serviceName": "CouriersPlease - Signature - 5kg (5kg)",
                "countries": [
                    "AU"
                ]
            }
        ]
    },
    {
        "carrierCode": "CTT",
        "carrierName": "CTT",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "CTT_Devolucion_Recogida_24_AM",
                "serviceName": "CTT - Devolucion + Recogida 24 AM",
                "countries": [
                    "PT"
                ]
            },
            {
                "serviceCode": "CTT_Devolucion_Recogida_24_PM",
                "serviceName": "CTT - Devolucion + Recogida 24 PM",
                "countries": [
                    "PT"
                ]
            },
            {
                "serviceCode": "CTT_Devolucion_Recogida_48_AM",
                "serviceName": "CTT - Devolucion + Recogida 48 AM",
                "countries": [
                    "PT"
                ]
            },
            {
                "serviceCode": "CTT_Devolucion_Recogida_48_PM",
                "serviceName": "CTT - Devolucion + Recogida 48 PM",
                "countries": [
                    "PT"
                ]
            },
            {
                "serviceCode": "CTT_Devolucion_Recogida_AM_Baleares_Economy",
                "serviceName": "CTT - Devolucion + Recogida AM Baleares Economy",
                "countries": [
                    "PT"
                ]
            },
            {
                "serviceCode": "CTT_Devolucion_Recogida_AM_Baleares_Express",
                "serviceName": "CTT - Devolucion + Recogida AM Baleares Express",
                "countries": [
                    "PT"
                ]
            },
            {
                "serviceCode": "CTT_Devolucion_Recogida_PM_Baleares_Economy",
                "serviceName": "CTT - Devolucion + Recogida PM Baleares Economy",
                "countries": [
                    "PT"
                ]
            },
            {
                "serviceCode": "CTT_Devolucion_Recogida_PM_Baleares_Express",
                "serviceName": "CTT - Devolucion + Recogida PM Baleares Express",
                "countries": [
                    "PT"
                ]
            },
            {
                "serviceCode": "CTT_EasyReturn",
                "serviceName": "CTT - EasyReturn",
                "countries": [
                    "PT"
                ]
            },
            {
                "serviceCode": "CTT_Express_Balearic_Pick_Return",
                "serviceName": "CTT - Express Balearic Pick + Return",
                "countries": [
                    "PT"
                ]
            },
            {
                "serviceCode": "CTT_Express_Pick_Return",
                "serviceName": "CTT - Express Pick + Return",
                "countries": [
                    "PT"
                ]
            }
        ]
    },
    {
        "carrierCode": "DHL",
        "carrierName": "DHL",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "DHL_Documents",
                "serviceName": "DHL - Documents",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "DHL_Domestic_Express",
                "serviceName": "DHL - Domestic Express",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "DHL_Express",
                "serviceName": "DHL - Express",
                "countries": [
                    "NL",
                    "FR"
                ]
            },
            {
                "serviceCode": "DHL_Express_0900",
                "serviceName": "DHL - Express 0900",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "DHL_Express_1200",
                "serviceName": "DHL - Express 1200",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "DHL_Express_Worldwide_Easyship",
                "serviceName": "DHL - Express Worldwide (Easyship)",
                "countries": [
                    "CA"
                ]
            }
        ]
    },
    {
        "carrierCode": "DHL_DE",
        "carrierName": "DHL DE",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "DHL_Economy_Select",
                "serviceName": "DHL - Economy Select",
                "countries": [
                    "DE"
                ]
            },
            {
                "serviceCode": "DHL_Express_09",
                "serviceName": "DHL - Express 09",
                "countries": [
                    "DE"
                ]
            },
            {
                "serviceCode": "DHL_Express_10_30",
                "serviceName": "DHL - Express 10:30",
                "countries": [
                    "DE"
                ]
            },
            {
                "serviceCode": "DHL_Express_12",
                "serviceName": "DHL - Express 12",
                "countries": [
                    "DE"
                ]
            },
            {
                "serviceCode": "DHL_Express_18",
                "serviceName": "DHL - Express 18",
                "countries": [
                    "DE"
                ]
            },
            {
                "serviceCode": "DHL_Express_Worldwide",
                "serviceName": "DHL - Express Worldwide",
                "countries": [
                    "DE"
                ]
            },
            {
                "serviceCode": "DHL_Paket_Return",
                "serviceName": "DHL- Paket Return",
                "countries": [
                    "DE"
                ]
            },
            {
                "serviceCode": "DHL_Paket_Return_service_point",
                "serviceName": "DHL- Paket Return service point",
                "countries": [
                    "DE"
                ]
            }
        ]
    },
    {
        "carrierCode": "DHL_Express",
        "carrierName": "DHL Express",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "DHL_Express_Worldwide",
                "serviceName": "DHL Express - Worldwide",
                "countries": [
                    "US",
                    "NL"
                ]
            }
        ]
    },
    {
        "carrierCode": "DPD",
        "carrierName": "DPD",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "DPD_Air_Classic",
                "serviceName": "DPD - Air Classic",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "DPD_Classic_Expresspak",
                "serviceName": "DPD - Classic Expresspak",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "DPD_Classic_Parcel",
                "serviceName": "DPD - Classic Parcel",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "DPD_Expresspak_Next_Day_NextDay",
                "serviceName": "DPD - Expresspak Next Day (NextDay)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "DPD_Parcel_IOSS",
                "serviceName": "DPD - Parcel (IOSS)",
                "countries": [
                    "UK"
                ]
            }
        ]
    },
    {
        "carrierCode": "DPD_AT",
        "carrierName": "DPD AT",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "DPD_Austria_Return",
                "serviceName": "DPD Austria - Return",
                "countries": [
                    "AT"
                ]
            }
        ]
    },
    {
        "carrierCode": "DPD_DE",
        "carrierName": "DPD DE",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "DPD_Classic_return",
                "serviceName": "DPD - Classic return",
                "countries": [
                    "DE"
                ]
            },
            {
                "serviceCode": "DPD_Home_Return",
                "serviceName": "DPD - Home Return",
                "countries": [
                    "DE"
                ]
            },
            {
                "serviceCode": "DPD_Return",
                "serviceName": "DPD - Return",
                "countries": [
                    "DE"
                ]
            }
        ]
    },
    {
        "carrierCode": "DPD_FR",
        "carrierName": "DPD FR",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "DPD_Predict_Return",
                "serviceName": "DPD - Predict Return",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "DPD_Relais_Return",
                "serviceName": "DPD - Relais Return",
                "countries": [
                    "FR"
                ]
            }
        ]
    },
    {
        "carrierCode": "Evri_Hermes",
        "carrierName": "Evri (Hermes)",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Evri_Collection_Return_Standard_Delivery",
                "serviceName": "Evri - Collection Return Standard Delivery",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "Evri_International_Parcelshop",
                "serviceName": "Evri - International Parcelshop",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "Evri_Light_and_Large",
                "serviceName": "Evri - Light and Large",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "Evri_Locker_to_Address_Returns",
                "serviceName": "Evri - Locker to Address Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "Evri_Next_Day_Parcelshop",
                "serviceName": "Evri - Next Day Parcelshop",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "Evri_Parcelshop_Returns",
                "serviceName": "Evri - Parcelshop Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "Evri_Parcelshop_to_Address_QR_Returns",
                "serviceName": "Evri - Parcelshop to Address QR Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "Evri_Parcelshop_to_Address_Returns",
                "serviceName": "Evri - Parcelshop to Address Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "Evri_Postable_Next_Day",
                "serviceName": "Evri - Postable Next Day",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "Evri_Returns",
                "serviceName": "Evri - Returns",
                "countries": [
                    "GB"
                ]
            }
        ]
    },
    {
        "carrierCode": "FedEx",
        "carrierName": "FedEx",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "FedEx_2Day_R",
                "serviceName": "FedEx 2Day®",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "FedEx_2Day_R_A_M",
                "serviceName": "FedEx 2Day® A.M.",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "FedEx_Economy_Returns",
                "serviceName": "FedEx - Economy Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "FedEx_Europe_first_Returns",
                "serviceName": "FedEx - Europe first Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "FedEx_Express_Saver_R",
                "serviceName": "FedEx Express Saver®",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "FedEx_Global_Returns",
                "serviceName": "FedEx - Global Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "FedEx_Ground_R",
                "serviceName": "FedEx Ground®",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "FedEx_Ground_R_Economy",
                "serviceName": "FedEx Ground® Economy",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "FedEx_Home_Delivery_R",
                "serviceName": "FedEx Home Delivery®",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "FedEx_International_Connect_Plus_Returns",
                "serviceName": "FedEx - International Connect Plus Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "FedEx_International_Economy_MyFlyingBox",
                "serviceName": "FedEx - International Economy (MyFlyingBox)",
                "countries": [
                    "DE"
                ]
            },
            {
                "serviceCode": "FedEx_International_Economy_R",
                "serviceName": "FedEx International Economy®",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "FedEx_International_Economy_Returns",
                "serviceName": "FedEx - International Economy Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "FedEx_International_first_Returns",
                "serviceName": "FedEx - International first Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "FedEx_International_Priority_MyFlyingBox",
                "serviceName": "FedEx - International Priority (MyFlyingBox)",
                "countries": [
                    "DE"
                ]
            },
            {
                "serviceCode": "FedEx_International_Priority_OWC",
                "serviceName": "FedEx - International Priority (OWC)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "FedEx_International_Priority_R",
                "serviceName": "FedEx International Priority®",
                "countries": [
                    "SG",
                    "US"
                ]
            },
            {
                "serviceCode": "FedEx_International_Priority_Returns",
                "serviceName": "FedEx - International Priority Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "FedEx_Priority_Overnight_R",
                "serviceName": "FedEx Priority Overnight®",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "FedEx_Priority_Overnight_Returns",
                "serviceName": "FedEx - Priority Overnight Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "FedEx_R_International_Connect_Plus",
                "serviceName": "FedEx® International Connect Plus",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "FedEx_Regional_Economy_Freight_Returns",
                "serviceName": "FedEx - Regional Economy Freight Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "FedEx_Returns",
                "serviceName": "FedEx - Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "FedEx_Standard_Overnight_R",
                "serviceName": "FedEx Standard Overnight®",
                "countries": [
                    "US"
                ]
            }
        ]
    },
    {
        "carrierCode": "GlobalPost",
        "carrierName": "GlobalPost",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "GlobalPost_Economy",
                "serviceName": "GlobalPost - Economy",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "GlobalPost_Standard",
                "serviceName": "GlobalPost - Standard",
                "countries": [
                    "US"
                ]
            }
        ]
    },
    {
        "carrierCode": "HK_Post",
        "carrierName": "HK Post",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "HK_Post_Air_Mail_Tracking",
                "serviceName": "HK Post Air Mail - Tracking",
                "countries": [
                    "HK"
                ]
            },
            {
                "serviceCode": "HK_Post_Air_Parcel_PE_P",
                "serviceName": "HK Post - Air Parcel PE (P)",
                "countries": [
                    "HK"
                ]
            },
            {
                "serviceCode": "HK_Post_Air_Parcel_XP",
                "serviceName": "HK Post - Air Parcel XP",
                "countries": [
                    "HK"
                ]
            },
            {
                "serviceCode": "HK_Post_e_Express",
                "serviceName": "HK Post - e-Express+",
                "countries": [
                    "HK"
                ]
            },
            {
                "serviceCode": "HK_Post_Local_Parcel",
                "serviceName": "HK Post - Local Parcel",
                "countries": [
                    "HK"
                ]
            },
            {
                "serviceCode": "HK_Post_Speedpost",
                "serviceName": "HK Post - Speedpost",
                "countries": [
                    "HK"
                ]
            }
        ]
    },
    {
        "carrierCode": "Hubbed_Easy_Returns",
        "carrierName": "Hubbed Easy Returns",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Hubbed_Easy_Returns",
                "serviceName": "Hubbed Easy Returns",
                "countries": [
                    "AU"
                ]
            }
        ]
    },
    {
        "carrierCode": "InPost",
        "carrierName": "InPost",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "InPost_Instant_Returns",
                "serviceName": "InPost - Instant Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "InPost_Locker_2_Locker_Returns",
                "serviceName": "InPost - Locker 2 Locker Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "InPost_Locker_to_Address_Returns",
                "serviceName": "InPost - Locker to Address Returns",
                "countries": [
                    "GB"
                ]
            },
            {
                "serviceCode": "InPost_Returns",
                "serviceName": "InPost - Returns",
                "countries": [
                    "GB"
                ]
            }
        ]
    },
    {
        "carrierCode": "InPost_ES",
        "carrierName": "InPost ES",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "InPost_Devolucion_Punto_de_Servicio_Internacional",
                "serviceName": "InPost - Devolucion Punto de Servicio Internacional",
                "countries": [
                    "ES"
                ]
            },
            {
                "serviceCode": "InPost_Devolucion_Punto_de_Servicio_Internacional_QR",
                "serviceName": "InPost - Devolucion Punto de Servicio Internacional QR",
                "countries": [
                    "ES"
                ]
            },
            {
                "serviceCode": "InPost_Devolucion_Punto_de_Servicio_Nacional",
                "serviceName": "InPost - Devolucion Punto de Servicio Nacional",
                "countries": [
                    "ES"
                ]
            },
            {
                "serviceCode": "InPost_Devolucion_Punto_de_Servicio_Nacional_QR",
                "serviceName": "InPost - Devolucion Punto de Servicio Nacional QR",
                "countries": [
                    "ES"
                ]
            },
            {
                "serviceCode": "InPost_Internacional_Devolucion",
                "serviceName": "InPost - Internacional Devolucion",
                "countries": [
                    "ES"
                ]
            },
            {
                "serviceCode": "InPost_Nacional_Devolucion",
                "serviceName": "InPost - Nacional Devolucion",
                "countries": [
                    "ES"
                ]
            },
            {
                "serviceCode": "InPost_Nacional_Devolucion_QR",
                "serviceName": "InPost - Nacional Devolucion QR",
                "countries": [
                    "ES"
                ]
            },
            {
                "serviceCode": "InPost_Punto_Pack_I_Locker_Retorno",
                "serviceName": "InPost - Punto Pack I Locker - Retorno",
                "countries": [
                    "ES"
                ]
            },
            {
                "serviceCode": "InPost_Punto_Pack_International_Retorno",
                "serviceName": "InPost - Punto Pack International - Retorno",
                "countries": [
                    "ES"
                ]
            }
        ]
    },
    {
        "carrierCode": "InPost_IT",
        "carrierName": "InPost IT",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "InPost_International_Returns",
                "serviceName": "InPost - International Returns",
                "countries": [
                    "IT"
                ]
            },
            {
                "serviceCode": "InPost_Returns",
                "serviceName": "InPost - Returns",
                "countries": [
                    "IT"
                ]
            }
        ]
    },
    {
        "carrierCode": "J_T_Express",
        "carrierName": "J&T Express",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "J_T_Express_Domestic",
                "serviceName": "J&T Express - Domestic",
                "countries": [
                    "SG"
                ]
            }
        ]
    },
    {
        "carrierCode": "Janio",
        "carrierName": "Janio",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Janio_Express",
                "serviceName": "Janio - Express",
                "countries": [
                    "SG"
                ]
            }
        ]
    },
    {
        "carrierCode": "Mondial_Realy",
        "carrierName": "Mondial Realy",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Mondial_Relay_International_home",
                "serviceName": "Mondial Relay - International, home",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Mondial_Relay_International_home_QR",
                "serviceName": "Mondial Relay - International, home, QR",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Mondial_Relay_International_return",
                "serviceName": "Mondial Relay - International return",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Mondial_Relay_International_return_QR",
                "serviceName": "Mondial Relay - International return, QR",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Mondial_Relay_International_return_relay",
                "serviceName": "Mondial Relay - International return relay",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Mondial_Relay_International_return_relay_QR",
                "serviceName": "Mondial Relay - International return relay, QR",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Mondial_Relay_Return",
                "serviceName": "Mondial Relay - Return",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Mondial_Relay_Return_QR",
                "serviceName": "Mondial Relay - Return, QR",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "Mondial_Relay_Return_relay",
                "serviceName": "Mondial Relay - Return relay",
                "countries": [
                    "FR"
                ]
            }
        ]
    },
    {
        "carrierCode": "NinjaVan",
        "carrierName": "NinjaVan",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "NinjaVan_Next_Day",
                "serviceName": "NinjaVan Next Day",
                "countries": [
                    "SG"
                ]
            },
            {
                "serviceCode": "NinjaVan_Standard",
                "serviceName": "NinjaVan Standard",
                "countries": [
                    "SG"
                ]
            }
        ]
    },
    {
        "carrierCode": "NZ_Post",
        "carrierName": "NZ Post",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "NZ_Post_Air_Small_Parcel",
                "serviceName": "NZ Post - Air Small Parcel",
                "countries": [
                    "NZ"
                ]
            },
            {
                "serviceCode": "NZ_Post_Economy_Parcel",
                "serviceName": "NZ Post - Economy Parcel",
                "countries": [
                    "NZ"
                ]
            },
            {
                "serviceCode": "NZ_Post_International_Courier",
                "serviceName": "NZ Post - International Courier",
                "countries": [
                    "NZ"
                ]
            },
            {
                "serviceCode": "NZ_Post_Parcel_Local",
                "serviceName": "NZ Post - Parcel Local",
                "countries": [
                    "NZ"
                ]
            }
        ]
    },
    {
        "carrierCode": "Parcelforce",
        "carrierName": "Parcelforce",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Parcelforce_Euro_Economy_Dropoff_Dropoff",
                "serviceName": "Parcelforce - Euro Economy Dropoff (Dropoff)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Parcelforce_Euro_Economy_Pickup_Pickup",
                "serviceName": "Parcelforce - Euro Economy Pickup (Pickup)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Parcelforce_Express_09_00_Dropoff",
                "serviceName": "Parcelforce - Express 09:00 (Dropoff)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Parcelforce_Express_09_00_Pickup",
                "serviceName": "Parcelforce - Express 09:00 (Pickup)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Parcelforce_Express_10_00_Dropoff",
                "serviceName": "Parcelforce - Express 10:00 (Dropoff)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Parcelforce_Express_10_00_Pickup",
                "serviceName": "Parcelforce - Express 10:00 (Pickup)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Parcelforce_Express_24_Dropoff",
                "serviceName": "Parcelforce - Express 24 (Dropoff)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Parcelforce_Express_24_Pickup",
                "serviceName": "Parcelforce - Express 24 (Pickup)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Parcelforce_Express_48_Dropoff",
                "serviceName": "Parcelforce - Express 48 (Dropoff)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Parcelforce_Express_48_Large_Pickup",
                "serviceName": "Parcelforce - Express 48 Large (Pickup)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Parcelforce_Express_48_Pickup",
                "serviceName": "Parcelforce - Express 48 (Pickup)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Parcelforce_Express_AM_Dropoff",
                "serviceName": "Parcelforce - Express AM (Dropoff)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Parcelforce_Express_AM_Pickup",
                "serviceName": "Parcelforce - Express AM (Pickup)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Parcelforce_Global_Priority_Dropoff",
                "serviceName": "Parcelforce - Global Priority (Dropoff)",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "Parcelforce_Global_Priority_Pickup",
                "serviceName": "Parcelforce - Global Priority (Pickup)",
                "countries": [
                    "UK"
                ]
            }
        ]
    },
    {
        "carrierCode": "Passport",
        "carrierName": "Passport",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Passport_Priority_Delcon",
                "serviceName": "Passport - Priority Delcon",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Passport_Priority_Delcon_DDP",
                "serviceName": "Passport - Priority Delcon DDP",
                "countries": [
                    "US"
                ]
            }
        ]
    },
    {
        "carrierCode": "PostNL",
        "carrierName": "PostNL",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "PostNL_Consolidation_returns",
                "serviceName": "PostNL - Consolidation returns",
                "countries": [
                    "NL"
                ]
            },
            {
                "serviceCode": "PostNL_Domestic",
                "serviceName": "PostNL - Domestic",
                "countries": [
                    "NL"
                ]
            },
            {
                "serviceCode": "PostNL_Home_pickup",
                "serviceName": "PostNL - Home pickup",
                "countries": [
                    "NL"
                ]
            },
            {
                "serviceCode": "PostNL_Home_pickup_bulky",
                "serviceName": "PostNL - Home pickup, bulky",
                "countries": [
                    "NL"
                ]
            },
            {
                "serviceCode": "PostNL_International_premium_returns",
                "serviceName": "PostNL - International premium returns",
                "countries": [
                    "NL"
                ]
            },
            {
                "serviceCode": "PostNL_International_returns",
                "serviceName": "PostNL - International returns",
                "countries": [
                    "NL"
                ]
            },
            {
                "serviceCode": "PostNL_Mailbox_Parcel_Return",
                "serviceName": "PostNL - Mailbox Parcel Return",
                "countries": [
                    "NL"
                ]
            },
            {
                "serviceCode": "PostNL_Pakket_Belgium",
                "serviceName": "PostNL - Pakket Belgium",
                "countries": [
                    "NL"
                ]
            }
        ]
    },
    {
        "carrierCode": "Purolator",
        "carrierName": "Purolator",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Purolator_Express_R",
                "serviceName": "Purolator - Express®",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Purolator_Ground_R",
                "serviceName": "Purolator - Ground®",
                "countries": [
                    "CA"
                ]
            }
        ]
    },
    {
        "carrierCode": "Quantium",
        "carrierName": "Quantium",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Quantium_International_ePAC",
                "serviceName": "Quantium - International ePAC",
                "countries": [
                    "HK"
                ]
            },
            {
                "serviceCode": "Quantium_Q_Smart",
                "serviceName": "Quantium - Q-Smart",
                "countries": [
                    "HK"
                ]
            },
            {
                "serviceCode": "Quantium_Q_Sure_AU",
                "serviceName": "Quantium - Q-Sure (AU)",
                "countries": [
                    "HK"
                ]
            }
        ]
    },
    {
        "carrierCode": "Sendle",
        "carrierName": "Sendle",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Sendle_2_Day_Guaranteed_Pickup_Pickup",
                "serviceName": "Sendle - 2 Day Guaranteed Pickup (Pickup)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Sendle_3_Day_Guaranteed_Pickup_Pickup",
                "serviceName": "Sendle 3-Day Guaranteed Pickup (Pickup)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Sendle_Preferred_Drop_Off_Dropoff",
                "serviceName": "Sendle - Preferred Drop Off (Dropoff)",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Sendle_Preferred_Pick_up_Pickup",
                "serviceName": "Sendle - Preferred Pick up (Pickup)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "Sendle_Preferred_Pickup_Pickup",
                "serviceName": "Sendle - Preferred Pickup (Pickup)",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "Sendle_Standard_Dropoff",
                "serviceName": "Sendle - Standard Dropoff",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "Sendle_Standard_Pickup",
                "serviceName": "Sendle - Standard Pickup",
                "countries": [
                    "AU"
                ]
            }
        ]
    },
    {
        "carrierCode": "Seur",
        "carrierName": "Seur",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "SEUR_24_Retorno",
                "serviceName": "SEUR - 24 Retorno",
                "countries": [
                    "ES"
                ]
            },
            {
                "serviceCode": "SEUR_48_Retorno_Recogida",
                "serviceName": "SEUR - 48 Retorno + Recogida",
                "countries": [
                    "ES"
                ]
            },
            {
                "serviceCode": "SEUR_Classic",
                "serviceName": "SEUR - Classic",
                "countries": [
                    "ES"
                ]
            },
            {
                "serviceCode": "SEUR_Retorno",
                "serviceName": "SEUR - Retorno",
                "countries": [
                    "ES"
                ]
            }
        ]
    },
    {
        "carrierCode": "SF_Express",
        "carrierName": "SF Express",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "SF_Express_Domestic",
                "serviceName": "SF Express - Domestic",
                "countries": [
                    "HK"
                ]
            },
            {
                "serviceCode": "SF_Express_E_Parcel_Registered_US",
                "serviceName": "SF Express - E-Parcel Registered (US)",
                "countries": [
                    "HK"
                ]
            },
            {
                "serviceCode": "SF_Express_Economy_Express",
                "serviceName": "SF Express - Economy Express",
                "countries": [
                    "HK"
                ]
            },
            {
                "serviceCode": "SF_Express_Economy_Express_LAX",
                "serviceName": "SF Express - Economy Express (LAX)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "SF_Express_Economy_Express_Pickup",
                "serviceName": "SF Express - Economy Express (Pickup)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "SF_Express_Local_FSCMOTW",
                "serviceName": "SF Express - Local (FSCMOTW)",
                "countries": [
                    "HK"
                ]
            },
            {
                "serviceCode": "SF_Express_Standard_Express_Pickup",
                "serviceName": "SF Express - Standard Express (Pickup)",
                "countries": [
                    "HK",
                    "US"
                ]
            }
        ]
    },
    {
        "carrierCode": "Singpost",
        "carrierName": "Singpost",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "SingPost_International_SpeedPost_Express",
                "serviceName": "SingPost - International SpeedPost Express",
                "countries": [
                    "SG"
                ]
            },
            {
                "serviceCode": "SingPost_International_SpeedPost_Priority",
                "serviceName": "SingPost - International SpeedPost Priority",
                "countries": [
                    "SG"
                ]
            },
            {
                "serviceCode": "SingPost_NextDay",
                "serviceName": "SingPost - NextDay",
                "countries": [
                    "SG"
                ]
            },
            {
                "serviceCode": "Singpost_NSaver",
                "serviceName": "Singpost - NSaver",
                "countries": [
                    "SG"
                ]
            }
        ]
    },
    {
        "carrierCode": "SkyPostal",
        "carrierName": "SkyPostal",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "SkyPostal_Packet_Express",
                "serviceName": "SkyPostal - Packet Express",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "SkyPostal_Postal_Packet_Standard",
                "serviceName": "SkyPostal - Postal Packet Standard",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "SkyPostal_Standard_Private_Delivery",
                "serviceName": "SkyPostal - Standard Private Delivery",
                "countries": [
                    "US"
                ]
            }
        ]
    },
    {
        "carrierCode": "Team_Global_Express",
        "carrierName": "Team Global Express",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "Team_Global_Express_Parcel",
                "serviceName": "Team Global Express - Parcel",
                "countries": [
                    "AU"
                ]
            }
        ]
    },
    {
        "carrierCode": "TNT",
        "carrierName": "TNT",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "TNT_Express_09_00_OWC",
                "serviceName": "TNT - Express 09:00 (OWC)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "TNT_Express_10_00_OWC",
                "serviceName": "TNT - Express 10:00 (OWC)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "TNT_Express_12_00_OWC",
                "serviceName": "TNT - Express 12:00 (OWC)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "TNT_Overnight",
                "serviceName": "TNT - Overnight",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "TNT_Road_Express",
                "serviceName": "TNT - Road Express",
                "countries": [
                    "AU"
                ]
            }
        ]
    },
    {
        "carrierCode": "TracX_Logis",
        "carrierName": "TracX Logis",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "TracX_Logis_Domestic",
                "serviceName": "TracX Logis - Domestic",
                "countries": [
                    "SG"
                ]
            },
            {
                "serviceCode": "TracX_Logis_International",
                "serviceName": "TracX Logis - International",
                "countries": [
                    "SG"
                ]
            },
            {
                "serviceCode": "TracX_Logis_International_MYEast",
                "serviceName": "TracX Logis - International (MYEast)",
                "countries": [
                    "SG"
                ]
            }
        ]
    },
    {
        "carrierCode": "UPS",
        "carrierName": "UPS",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "UPS_2nd_Day_Air_A_M_R",
                "serviceName": "UPS 2nd Day Air A.M. ®",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "UPS_2nd_Day_Air_R",
                "serviceName": "UPS 2nd Day Air®",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "UPS_3_Day_Select_R",
                "serviceName": "UPS 3 Day Select®",
                "countries": [
                    "US",
                    "CA"
                ]
            },
            {
                "serviceCode": "UPS_Expedited",
                "serviceName": "UPS Expedited",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "UPS_Expedited_R",
                "serviceName": "UPS Expedited®",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "UPS_Expedited_TM_MyFlyingBox",
                "serviceName": "UPS Expedited™ (MyFlyingBox)",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "UPS_Express_Early_R",
                "serviceName": "UPS Express Early®",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "UPS_Express_Plus_R",
                "serviceName": "UPS Express Plus®",
                "countries": [
                    "UK"
                ]
            },
            {
                "serviceCode": "UPS_Express_R",
                "serviceName": "UPS Express®",
                "countries": [
                    "CA",
                    "UK"
                ]
            },
            {
                "serviceCode": "UPS_Express_Saver_R",
                "serviceName": "UPS Express Saver®",
                "countries": [
                    "CA",
                    "UK"
                ]
            },
            {
                "serviceCode": "UPS_Express_Saver_R_OWC",
                "serviceName": "UPS - Express Saver® (OWC)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "UPS_Express_Saver_Return",
                "serviceName": "UPS - Express Saver Return",
                "countries": [
                    "DE"
                ]
            },
            {
                "serviceCode": "UPS_Next_Day_Air_R",
                "serviceName": "UPS Next Day Air®",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "UPS_Next_Day_Air_R_Early",
                "serviceName": "UPS Next Day Air® Early",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "UPS_Next_Day_Air_Saver_R",
                "serviceName": "UPS Next Day Air Saver®",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "UPS_Premium_Return",
                "serviceName": "UPS - Premium Return",
                "countries": [
                    "DE"
                ]
            },
            {
                "serviceCode": "UPS_R_Ground",
                "serviceName": "UPS® Ground",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "UPS_R_Ground_Saver",
                "serviceName": "UPS® Ground Saver",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "UPS_R_Ground_Saver_1lb",
                "serviceName": "UPS® Ground Saver (1lb)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "UPS_R_Standard",
                "serviceName": "UPS® Standard",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "UPS_R_Standard_MyFlyingBox",
                "serviceName": "UPS® Standard (MyFlyingBox)",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "UPS_Standard_R",
                "serviceName": "UPS Standard®",
                "countries": [
                    "CA",
                    "UK"
                ]
            },
            {
                "serviceCode": "UPS_Standard_Return",
                "serviceName": "UPS - Standard Return",
                "countries": [
                    "DE"
                ]
            },
            {
                "serviceCode": "UPS_Worldwide_Expedited_R",
                "serviceName": "UPS Worldwide Expedited®",
                "countries": [
                    "US",
                    "SG",
                    "CA"
                ]
            },
            {
                "serviceCode": "UPS_Worldwide_Expedited_R_Pickup",
                "serviceName": "UPS Worldwide Expedited® (Pickup)",
                "countries": [
                    "HK"
                ]
            },
            {
                "serviceCode": "UPS_Worldwide_Express_Plus_R",
                "serviceName": "UPS Worldwide Express Plus®",
                "countries": [
                    "SG",
                    "HK"
                ]
            },
            {
                "serviceCode": "UPS_Worldwide_Express_Plus_R_MyFlyingBox",
                "serviceName": "UPS Worldwide Express Plus® (MyFlyingBox)",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "UPS_Worldwide_Express_Plus_TM",
                "serviceName": "UPS Worldwide Express Plus™",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "UPS_Worldwide_Express_R",
                "serviceName": "UPS Worldwide Express®",
                "countries": [
                    "US",
                    "SG",
                    "HK"
                ]
            },
            {
                "serviceCode": "UPS_Worldwide_Express_Saver_R",
                "serviceName": "UPS Worldwide Express Saver®",
                "countries": [
                    "CA"
                ]
            },
            {
                "serviceCode": "UPS_Worldwide_Saver_R",
                "serviceName": "UPS Worldwide Saver®",
                "countries": [
                    "US",
                    "SG",
                    "NZ"
                ]
            },
            {
                "serviceCode": "UPS_Worldwide_Saver_R_MyFlyingBox",
                "serviceName": "UPS Worldwide Saver® (MyFlyingBox)",
                "countries": [
                    "FR"
                ]
            },
            {
                "serviceCode": "UPS_Worldwide_Saver_R_OWC",
                "serviceName": "UPS - Worldwide Saver® (OWC)",
                "countries": [
                    "AU"
                ]
            },
            {
                "serviceCode": "UPS_Worldwide_Saver_R_pickup",
                "serviceName": "UPS Worldwide Saver® (pickup)",
                "countries": [
                    "HK"
                ]
            },
            {
                "serviceCode": "UPS_Worldwise_Express_TM",
                "serviceName": "UPS Worldwise Express™",
                "countries": [
                    "CA"
                ]
            }
        ]
    },
    {
        "carrierCode": "USPS",
        "carrierName": "USPS",
        "carrierLogo": "",
        "list": [
            {
                "serviceCode": "USPS_First_Class_International",
                "serviceName": "USPS - First Class International",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_Envelope_Envelope",
                "serviceName": "USPS - Flat Rate Priority Mail - Envelope (Envelope)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_Express_Envelope_Envelope",
                "serviceName": "USPS - Flat Rate Priority Mail Express - Envelope (Envelope)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_Express_International_Envelope_Envelope",
                "serviceName": "USPS - Flat Rate Priority Mail Express International - Envelope (Envelope)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_Express_International_Legal_Envelope_Legal_Envelope",
                "serviceName": "USPS - Flat Rate Priority Mail Express International - Legal Envelope (Legal Envelope)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_Express_International_Padded_Envelope",
                "serviceName": "USPS - Flat Rate Priority Mail Express International - Padded Envelope",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_Express_Legal_Envelope_Legal_Envelope",
                "serviceName": "USPS - Flat Rate Priority Mail Express - Legal Envelope (Legal Envelope)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_Express_Padded_Envelope_Padded_Envelope",
                "serviceName": "USPS - Flat Rate Priority Mail Express - Padded Envelope (Padded Envelope)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_International_Envelope_Envelope",
                "serviceName": "USPS - Flat Rate Priority Mail International - Envelope (Envelope)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_International_Large_Large",
                "serviceName": "USPS - Flat Rate Priority Mail International - Large (Large)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_International_Large_Video_Box_Large_Video_Box",
                "serviceName": "USPS - Flat Rate Priority Mail International - Large Video Box (Large Video Box)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_International_Legal_Envelope_Legal_Envelope",
                "serviceName": "USPS - Flat Rate Priority Mail International - Legal Envelope (Legal Envelope)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_International_Medium_1_Medium_Box_1",
                "serviceName": "USPS - Flat Rate Priority Mail International - Medium 1 (Medium Box 1)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_International_Medium_2_Medium2",
                "serviceName": "USPS - Flat Rate Priority Mail International - Medium 2 (Medium2)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_International_Padded_Envelope_Padded_Envelope",
                "serviceName": "USPS - Flat Rate Priority Mail International - Padded Envelope (Padded Envelope)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_International_Small_Envelope_Small_Envelope",
                "serviceName": "USPS - Flat Rate Priority Mail International - Small Envelope (Small Envelope)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_International_Small_Small",
                "serviceName": "USPS - Flat Rate Priority Mail International - Small (Small)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_International_Window_Envelope_Window_Envelope",
                "serviceName": "USPS - Flat Rate Priority Mail International - Window Envelope (Window Envelope)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_Large",
                "serviceName": "USPS - Flat Rate Priority Mail - Large",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_Legal_Envelope_Legal_Envelope",
                "serviceName": "USPS - Flat Rate Priority Mail - Legal Envelope (Legal Envelope)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_Medium_1_Medium1",
                "serviceName": "USPS - Flat Rate Priority Mail - Medium 1 (Medium1)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_Medium_2",
                "serviceName": "USPS - Flat Rate Priority Mail - Medium 2",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_Padded_Envelope_USPS",
                "serviceName": "USPS - Flat Rate Priority Mail - Padded Envelope (USPS)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_Small_Envelope_Small_Envelope",
                "serviceName": "USPS - Flat Rate Priority Mail - Small Envelope (Small Envelope)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_Small_Small",
                "serviceName": "USPS - Flat Rate Priority Mail - Small (Small)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Flat_Rate_Priority_Mail_Window_Envelope_Window_Envelope",
                "serviceName": "USPS - Flat Rate Priority Mail - Window Envelope (Window Envelope)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Ground_Advantage",
                "serviceName": "USPS - Ground Advantage",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Ground_Advantage_Signature",
                "serviceName": "USPS - Ground Advantage Signature",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Light_Weight_Trackable",
                "serviceName": "USPS - Light Weight Trackable",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Light_Weight_Trackable_FlatStandard",
                "serviceName": "USPS - Light Weight Trackable (FlatStandard)",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Media",
                "serviceName": "USPS - Media",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Priority_Mail",
                "serviceName": "USPS - Priority Mail",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Priority_Mail_Express",
                "serviceName": "USPS - Priority Mail Express",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Priority_Mail_Express_International",
                "serviceName": "USPS - Priority Mail Express International",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Priority_Mail_International",
                "serviceName": "USPS - Priority Mail International",
                "countries": [
                    "US"
                ]
            },
            {
                "serviceCode": "USPS_Priority_Mail_Signature",
                "serviceName": "USPS - Priority Mail Signature",
                "countries": [
                    "US"
                ]
            }
        ]
    }
];

export default carrierSelectionOptions;